// ----------------------------------------------------------------------

const account = {
  displayName: 'Lessin',
  email: 'admin@lessin.pe',
  photoURL: '/assets/images/avatars/avatar_lessin.jpg',
};

export default account;
